"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SaveSearch = function SaveSearch(_ref) {
  var size = _ref.size,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, rest), _react.default.createElement("path", {
    d: "M29.458 40.053H7.47a1 1 0 0 1-1-1V16.975a1 1 0 1 1 2 0v21.078h20.988a1 1 0 1 1 0 2zM33.27 26.85a1 1 0 0 1-1-1v-8.875a1 1 0 1 1 2 0v8.875a1 1 0 0 1-1 1z"
  }), _react.default.createElement("path", {
    d: "M38.286 23.74a1 1 0 0 1-.75-.336L21.216 4.954 3.613 21.33a1 1 0 1 1-1.362-1.465L20.603 2.792a1.005 1.005 0 0 1 1.43.07l17 19.216a1 1 0 0 1-.748 1.664zM34.195 41.788c-4.635 0-8.405-3.813-8.405-8.5s3.77-8.5 8.405-8.5 8.405 3.814 8.405 8.5-3.77 8.5-8.405 8.5zm0-15c-3.532 0-6.405 2.916-6.405 6.5s2.873 6.5 6.405 6.5 6.405-2.916 6.405-6.5-2.873-6.5-6.405-6.5z"
  }), _react.default.createElement("path", {
    d: "M48.018 48.288a.996.996 0 0 1-.711-.297l-8.599-8.708a1 1 0 1 1 1.423-1.405l8.598 8.708a1 1 0 0 1-.71 1.702z"
  }), _react.default.createElement("path", {
    d: "M48.064 49.476c-.267 0-.523-.107-.711-.297l-3.316-3.358a1 1 0 0 1 0-1.407l1.004-1.016c.375-.38 1.046-.38 1.422 0l3.317 3.358a1 1 0 0 1 0 1.406l-1.004 1.017c-.188.19-.444.297-.712.297zM33.899 37.97c-2.474 0-4.487-2.032-4.487-4.531s2.013-4.531 4.487-4.531 4.487 2.032 4.487 4.53-2.013 4.532-4.487 4.532zm0-7.062c-1.371 0-2.487 1.135-2.487 2.53s1.116 2.532 2.487 2.532 2.487-1.136 2.487-2.531-1.116-2.531-2.487-2.531zM26.024 27.464H11.932a1 1 0 0 1-1-1v-7.522a1 1 0 0 1 1-1h14.092a1 1 0 0 1 1 1v7.522a1 1 0 0 1-1 1zm-13.092-2h12.092v-5.522H12.932v5.522zM31.557 15.942a1 1 0 0 1-1-1v-8h-1.165v4a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1h3.165a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1z"
  }));
};

SaveSearch.displayName = "SaveSearch";
SaveSearch.defaultProps = {
  size: 24,
  color: "currentColor"
};
var _default = SaveSearch;
exports.default = _default;